import { applyMiddleware, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import reducers from "./reducers/index";

export const middlewares = [thunkMiddleware];

const middleware = applyMiddleware(...middlewares);

// compose with dev tools is redux logger in browser
const store = createStore(reducers, composeWithDevTools(middleware));

export default store;



// WEBPACK FOOTER //
// ./src/store.js